<div class="pdf-grid-preview"
     [style.backgroundColor]="backgroundColor || 'transparent'">
  <div *ngFor="let cell of gridCells"
       class="grid-cell"
       [style.left.px]="cell.left"
       [style.top.px]="cell.top"
       [style.width.px]="cell.width"
       [style.height.px]="cell.height"
       [class.bordered]="showBorders"
       [style.borderColor]="borderColor"
       [style.borderWidth.px]="showBorders ? borderThickness : 0">
  </div>
  <div *ngIf="gridCells.length === 0" class="empty-grid">
    <mat-icon>grid_on</mat-icon>
    <span>Configure grid</span>
  </div>
</div>
